import { useTranslation } from 'react-i18next';

import type { FollowUpRemark } from '~/api/invoices/types';

type Props = {
  remark: FollowUpRemark | null;
};

export const RemarkAuthorLabel = ({ remark }: Props) => {
  const { t } = useTranslation(['invoices']);

  return remark?.causerType === 'user'
    ? t('invoices:details.paymentInfoDetail.remark.byUser')
    : t('invoices:details.paymentInfoDetail.remark.byAdmin', { name: remark?.causerName ?? '' });
};
